module.exports = __webpack_public_path__ + "img/birdlife-de.0a81bc12.svg";